<template>
  <div class="side">
    <div class="topbar-img">扫描下载脂玫乐app</div>
    <ul>
      <li class="displayB">
        <img
          :src="src1"
          alt=""
          title=""
        />
        <img
          :src="src2"
          class="displayNone"
          style="width: 140px; height: 140px"
          alt=""
          title=""
        />
      </li>
      <li class="displayB">
        <img
          :src="src3"
          alt=""
          title=""
        />
        <img
          :src="src4"
          alt=""
          title=""
          class="displayNone"
          style="width: 140px; height: 140px"
        />
      </li>
      <li>
        <a
          href="https://www.toutiao.com/c/user/619748942939964/#mid=1627878775647236"
          ><img
            :src="src5"
            alt=""
            title=""
        /></a>
      </li>
      <li>
        <a href="https://weibo.com/u/6259280293"
          ><img
            :src="src6"
            alt=""
            title=""
        /></a>
      </li>
      <li class="displayB">
        <img
          :src="src7"
          alt=""
          title=""
        />
        <img
          :src="src8"
          class="displayNone"
          style="width: 140px; height: 140px"
          alt=""
          title=""
        />
      </li>
      <li class="gotoTop" @click="toTop"></li>
    </ul>
  </div>
</template>
<script>
import { myFun } from "../../plug/modifyImagePath"
export default {
  name: "Sidebar",
  data() {
    return {
      imgcdoe: false,
      src1:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/douying.png'),
      src2:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/douyingcode.png'),
      src3:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/huoshan.png'),
      src4:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/huoshancode.png'),
      src5:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/toutiao.png'),
      src6:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/weibo.png'),
      src7:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/weixin.png'),
      src8:myFun('https://jusewebapp.oss-cn-hangzhou.aliyuncs.com/zml-gw/wxewm.png'),
    };
  },
  methods: {
    async toTop() {
      $("html,body").animate(
        {
          scrollTop: 0,
        },
        1200
      );
      // if (this.$route.name != 'hometest') {
      //
      // } else {
      // }
    },
    handleScroll() {
      let scrollTop = $(window).scrollTop();
      if (scrollTop > 500) {
        $(".topbar-img").fadeIn(800);
      } else {
        $(".topbar-img").fadeOut(800);
      }
      // console.log(scrollTop);
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
};
</script>
<style lang="less" scoped>
@import url("../../../static/css/fontSize.less");

.side {
  z-index: 99;
  position: fixed;
  top: 45%;
  right: 1%;
  text-align: right;
}

.side ul {
  margin-top: 10 * @width;
}

.side ul li {
}

.side ul li img {
  width: 40 * @width / 2;
  height: 40 * @width / 2;
}

.displayNone {
  display: none;
  position: absolute;
  bottom: 122 * @width / 2;
  right: 50 * @width / 2;
}

.displayB:hover .displayNone {
  display: block;
}

.gotoTop {
  display: inline-block;
  width: 20 * @width;
  height: 20 * @width;
  background: url("https://jusewebapp.zmelo.com/zml-gw/xiangshang.png")
    no-repeat;
  background-size: cover;
}

.gotoTop:hover {
  background: url("https://jusewebapp.zmelo.com/zml-gw/v1.1.1/topBut.png")
    no-repeat;
  background-size: cover;
}

.topbar-img {
  display: none;
  text-align: center;
  font-size: 6 * @width;
  padding-top: 58 * @width;
  width: 60 * @width;
  height: 70 * @width;
  background: url("https://jusewebapp.zmelo.com/zml-gw/v1.1.1/sidebarImg.png")
    no-repeat;
  background-size: cover;
}
</style>



// WEBPACK FOOTER //
// Sidebar.vue